import { render, staticRenderFns } from "./Presslogo.vue?vue&type=template&id=6f827b1e&"
import script from "./Presslogo.vue?vue&type=script&lang=js&"
export * from "./Presslogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports